import React from 'react';
import { ProgressBar } from 'primereact/progressbar';

const FloatingProgressBar = ({ progress, fileName, error, id, remove }) => {
  return (
    <div className="inner-card p-3 w-100 mb-2">
      <div>
        <div className="d-flex align-items-center mb-2">
          <i className="icon-files me-2"></i>

          {fileName && (
            <p className="mb-0" style={{ wordWrap: 'break-word' }}>
              {fileName}
            </p>
          )}
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <p className="text-hint mb-0">Downloading</p>
          <span>{progress} %</span>
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <ProgressBar value={progress} style={{ height: 10 }} className="w-100" displayValueTemplate={() => <></>} />
        </div>
        {error && <p className="mb-0 danger-text">Download Failed</p>}
      </div>
      {error && <i className="pi pi-times ms-2 cursor-pointer" onClick={() => remove(id)}></i>}
    </div>
  );
};

export default FloatingProgressBar;
